import React from "react";
import { useNavigate } from "react-router";

interface WatchPartiesModalProps {
  isOpen: boolean;
  onClose: () => void;
  filmTitle: string;
  watchParties: any[];
  onCreateParty: () => void;
}

const WatchPartiesModal: React.FC<WatchPartiesModalProps> = ({ isOpen, onClose, filmTitle, watchParties, onCreateParty }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={onClose}>
      <div
        className="bg-gray-900 border-2 border-red-600 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 shadow-[0_0_40px_rgba(220,38,38,0.5)] custom-scrollbar"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-white">Watch Parties for {filmTitle}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {watchParties.length === 0 ? (
          <div className="text-center text-gray-500 py-8">
            <p className="text-lg mb-4">No upcoming watch parties yet</p>
            <button
              onClick={() => {
                onClose();
                onCreateParty();
              }}
              className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
            >
              Create the First Party!
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {watchParties.map((party) => (
              <div key={party.id} className="bg-gray-800 border border-red-600 rounded-lg p-4">
                {/* Time */}
                <div className="flex items-center gap-2 text-cyan-400 mb-3">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="font-semibold">
                    {new Date(party.scheduled_time).toLocaleString(undefined, {
                      weekday: "short",
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>

                {/* Description */}
                {party.description && <p className="text-gray-300 mb-3">{party.description}</p>}

                {/* Join Button */}
                <button
                  onClick={() => {
                    onClose();
                    navigate("/watch-parties");
                  }}
                  className="w-full py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
                >
                  View Details & Join
                </button>
              </div>
            ))}

            {/* View All Button */}
            <button
              onClick={() => {
                onClose();
                navigate("/watch-parties");
              }}
              className="w-full py-2 text-red-400 hover:text-red-300 font-semibold transition-colors"
            >
              View All Watch Parties →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WatchPartiesModal;
